import React, { useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Button } from '../ui/button';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../ui/tabs';
import { WhaleAlertFeed } from './WhaleAlertFeed';
import { WhaleStats } from './WhaleStats';
import { TrackedWallets } from './TrackedWallets';
import { AccumulationTrends } from './AccumulationTrends';
import { WhaleSettings } from './WhaleSettings';
import { useWallet } from '../wallet/WalletProvider';
import { Fish, Bell, TrendingUp, Settings, Wallet } from 'lucide-react';

export function WhaleTrackingDashboard() {
  const { isConnected } = useWallet();
  const [activeTab, setActiveTab] = useState('alerts');
  const [showSettings, setShowSettings] = useState(false);

  if (!isConnected) {
    return (
      <Card className="max-w-md mx-auto">
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <Fish className="h-5 w-5 text-blue-500" />
            Whale Tracking
          </CardTitle>
        </CardHeader>
        <CardContent className="text-center space-y-4">
          <p className="text-slate-600 dark:text-slate-400">
            Conecta tu wallet para rastrear movimientos de ballenas en tiempo real.
          </p>
        </CardContent>
      </Card>
    );
  }

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
        <div>
          <h1 className="text-3xl font-bold text-slate-900 dark:text-slate-100 flex items-center gap-3">
            <Fish className="h-8 w-8 text-blue-500" />
            Whale Tracking
          </h1>
          <p className="text-slate-600 dark:text-slate-400 mt-2">
            Monitorea movimientos de ballenas y grandes transacciones en tiempo real
          </p>
        </div>
        <div className="flex gap-2">
          <Button
            variant="outline"
            onClick={() => setShowSettings(true)}
          >
            <Settings className="mr-2 h-4 w-4" />
            Configurar Alertas
          </Button>
        </div>
      </div>

      {/* Live Stats */}
      <WhaleStats />

      {/* Settings Modal */}
      {showSettings && (
        <WhaleSettings onClose={() => setShowSettings(false)} />
      )}

      {/* Main Content */}
      <Tabs value={activeTab} onValueChange={setActiveTab}>
        <TabsList className="grid w-full grid-cols-3">
          <TabsTrigger value="alerts" className="flex items-center gap-2">
            <Bell className="h-4 w-4" />
            Alertas
          </TabsTrigger>
          <TabsTrigger value="trends" className="flex items-center gap-2">
            <TrendingUp className="h-4 w-4" />
            Tendencias
          </TabsTrigger>
          <TabsTrigger value="wallets" className="flex items-center gap-2">
            <Wallet className="h-4 w-4" />
            Wallets
          </TabsTrigger>
        </TabsList>

        <TabsContent value="alerts" className="space-y-6">
          <WhaleAlertFeed />
        </TabsContent>

        <TabsContent value="trends" className="space-y-6">
          <AccumulationTrends />
        </TabsContent>

        <TabsContent value="wallets" className="space-y-6">
          <TrackedWallets />
        </TabsContent>
      </Tabs>
    </div>
  );
}
